import "babel-polyfill";
import "../configure";
import "../polyfills";
import "../main.css";
import renderBrowser from "../renderBrowser";
import siteProps from "../utilities/siteProps";

if (typeof document !== "undefined") {
  /*
   * Set publicPath if an override is defined in siteProps
   * ref:- https://webpack.js.org/guides/public-path/
   */
  if (typeof siteProps.current.basePath !== "undefined") {
    // eslint-disable-next-line no-undef, camelcase
    __webpack_public_path__ = siteProps.current.basePath;
  }

  renderBrowser();
}
